import React, { useEffect, useState } from "react";
import { Col, Form, Modal, Row } from "react-bootstrap";
import SbCancelBtn, { SBSaveUpdateBtn } from "../../Buttons/Buttons";
import Select from 'react-select';
import { ADDED_BY_ID } from "../../../Constants";
import { loadAssignedModulesDropdownData, loadSettingsModuleFieldForeignKeyColumnDropdown, postModuleFieldDatas } from "../../../redux/action";
import { useDispatch, useSelector } from "react-redux";
import * as HeaderAuthentication from '../../HeaderAuthentication'

const enablingOptions = [
    { value: 34, label: "Active" },
    { value: 35, label: "Inactive" }
]

const columnDataTypeOptions = [
    { value: "number", label: "number" },
    { value: "string", label: "string" },
    { value: "boolean", label: "boolean" },
    { value: "date", label: "date" },
];

const AddModuleField = (props) => {
    const dispatch = useDispatch();
    const { assignedModulesDropdown } = useSelector((state) => state.data);
    const { getColumnNameData } = useSelector((state) => state.data);
    const moduleFieldID = props.moduleFieldID;
    const getSingleModuleFieldData = props.getSingleModuleFieldData;

    const [showExtraFields, setShowExtraFields] = useState(false);

    const [moduleFields, setModuleFields] = useState({
        ModuleID: null,
        ModuleFieldName: "",
        ModuleFieldAliasName: "",
        PageName: "",
        ColumnDataType: "",
        IsForeignKey: false,
        ForeignKeyTableName: "",
        ForeignKeyColumnName: "",
        ForeignKeyColumnFieldName: "",
        AddedByID: ADDED_BY_ID, // optional prop fallback
    });

    const handleInputChange = (field, value) => {
        setModuleFields(prev => ({ ...prev, [field]: value }));
    };

    useEffect(() => {
        dispatch(loadAssignedModulesDropdownData());
        dispatch(loadSettingsModuleFieldForeignKeyColumnDropdown());
    }, []);

    useEffect(() => {
        if (moduleFieldID && getSingleModuleFieldData && getSingleModuleFieldData.length > 0) {
            const data = getSingleModuleFieldData[0];

            setModuleFields({
                ModuleFieldID: moduleFieldID,
                ModuleID: data.ModuleID || null,
                ModuleFieldName: data.ModuleFieldName || "",
                ModuleFieldAliasName: data.ModuleFieldAliasName || "",
                PageName: data.PageName || "",
                ColumnDataType: data.ColumnDataType || "",
                IsForeignKey: data.IsForeignKey || false,
                ForeignKeyTableName: data.ForeignKeyTableName || "",
                ForeignKeyColumnName: data.ForeignKeyColumnName || "",
                ForeignKeyColumnFieldName: data.ForeignKeyColumnFieldName || "",
                StatusID: data.StatusID || "", // use StatusID for value
                AddedByID: ADDED_BY_ID,
            });

            setShowExtraFields(data.IsForeignKey || false);
        } else {
            // Reset for add new
            setModuleFields({
                ModuleID: null,
                ModuleFieldName: "",
                ModuleFieldAliasName: "",
                PageName: "",
                ColumnDataType: "",
                IsForeignKey: false,
                ForeignKeyTableName: "",
                ForeignKeyColumnName: "",
                ForeignKeyColumnFieldName: "",
                StatusID: null,
                AddedByID: ADDED_BY_ID,
            });
            setShowExtraFields(false);
        }
    }, [moduleFieldID, getSingleModuleFieldData]);

    const AddModuleFieldData = (e) => {
        e.preventDefault();

        let requestOption = {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(moduleFields),
        };
        dispatch(postModuleFieldDatas(requestOption, props.handleCloseModal, props.moduleFieldData, moduleFieldID));
        console.log(moduleFields, 'moduleFields')
    }

    return (
        <>
            <Modal show={props.open} onHide={props.handleCloseModal} className='add-customer-modal add-role-modal'>
                <Modal.Header closeButton>
                    <Modal.Title>{moduleFieldID ? "Edit Module Field" : "Add Module Field"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row className='customer-form-fields'>
                        <Col>
                            <Row>
                                <Col md={4}>
                                    <div>
                                        <label>Module Name</label>
                                        <Select
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            options={assignedModulesDropdown}
                                            placeholder="Select"
                                            value={assignedModulesDropdown.find(opt => opt.value === moduleFields.ModuleID)}
                                            onChange={(selected) => handleInputChange("ModuleID", selected?.value)}
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                        />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>Field Name</label>
                                        <Form.Control
                                            type="text"
                                            value={moduleFields.ModuleFieldName}
                                            onChange={(e) => handleInputChange("ModuleFieldName", e.target.value)}
                                        />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>Alias Name</label>
                                        <Form.Control
                                            type="text"
                                            value={moduleFields.ModuleFieldAliasName}
                                            onChange={(e) => handleInputChange("ModuleFieldAliasName", e.target.value)}
                                        />
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <div>
                                        <label>Page Name</label>
                                        <Form.Control
                                            type="text"
                                            value={moduleFields.PageName}
                                            onChange={(e) => handleInputChange("PageName", e.target.value)}
                                        />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>Column Data Type</label>
                                        <Select
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            options={columnDataTypeOptions}
                                            placeholder="Select"
                                            value={columnDataTypeOptions.find(opt => opt.value === moduleFields.ColumnDataType)}
                                            onChange={(selected) => handleInputChange("ColumnDataType", selected?.value)}
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                        />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>Status</label>
                                        <Select
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            options={enablingOptions}
                                            placeholder="Select"
                                            value={enablingOptions.find(opt => opt.value === moduleFields.StatusID)}
                                            onChange={(selected) => handleInputChange("StatusID", selected?.value)}
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                        />
                                    </div>
                                </Col>
                            </Row>
                            {/* Checkbox to toggle extra fields */}
                            <Row className="mt-3">
                                <Col className="d-flex align-items-center">
                                    <Form.Check
                                        type="checkbox"
                                        label="Is Foreign Key"
                                        checked={moduleFields.IsForeignKey}
                                        onChange={(e) => {
                                            const checked = e.target.checked;
                                            setShowExtraFields(checked);
                                            handleInputChange("IsForeignKey", checked);
                                        }}
                                    />
                                </Col>
                            </Row>

                            {/* Extra fields displayed when checkbox is checked */}
                            {showExtraFields && (
                                <Row className="mt-2">
                                    <Col md={4}>
                                        <div>
                                            <label>Table Name</label>
                                            <Form.Control
                                                type="text"
                                                value={moduleFields.ForeignKeyTableName}
                                                onChange={(e) => handleInputChange("ForeignKeyTableName", e.target.value)}
                                            />
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div>
                                            <label>Column Name</label>
                                            <Select className="react-select-container" classNamePrefix="react-select"
                                                options={getColumnNameData}
                                                placeholder="Select"
                                                menuPosition="fixed"
                                                menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                                value={getColumnNameData.find(opt => opt.value === moduleFields.ForeignKeyColumnName)}
                                                onChange={(selected) => handleInputChange("ForeignKeyColumnName", selected?.value)}
                                            />
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div>
                                            <label>Column Field Name</label>
                                            <Select className="react-select-container"
                                                classNamePrefix="react-select"
                                                options={getColumnNameData}
                                                placeholder="Select"
                                                menuPosition="fixed"
                                                menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                                value={getColumnNameData.find(opt => opt.value === moduleFields.ForeignKeyColumnFieldName)}
                                                onChange={(selected) => handleInputChange("ForeignKeyColumnFieldName", selected?.value)}
                                            />
                                        </div>
                                    </Col>
                                </Row>
                            )}
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <SbCancelBtn btnName="Cancel" onClickEffect={props.handleCloseModal} />
                    <SBSaveUpdateBtn btnName="Submit" onClickEffect={AddModuleFieldData} />
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default AddModuleField;
